import { OutlinedInput, styled } from '@material-ui/core';

export const IntelligenceSearch = styled(OutlinedInput)(({ theme }) => ({
  minWidth: 400,
  // Make the entire input look like a pill
  borderRadius: 9999,
  // Give it a light background color
  backgroundColor: '#F8F9FA',
  // Set a consistent height
  height: 46,
  // Remove outline border or make it transparent by default
  '& $notchedOutline': {
    borderColor: 'transparent'
  },
  // Remove/hide outline border on hover
  '&:hover': {
    borderColor: 'transparent'
  },
  // Show a colored outline when focused (optional)
  '&.Mui-focused': {
    borderColor: theme.palette.primary.main,
    backgroundColor: '#fff !important'
  },
  '&.MuiOutlinedInput-root.MuiOutlinedInput-notchedOutline': {
    borderColor: 'red !important'
  },
  // Control the text styles and placeholder
  input: {
    color: 'red', // Text color
    padding: theme.spacing(1, 0)
  },

  '& fieldset': {
    border: '1px solid #AFBAC6 !important'
  },

  '& .MuiInputBase-input::placeholder': {
    color: '#5D7083', // replace with your color
    opacity: 1 // ensure it's visible
  }
}));
